exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".roll[data-v-0583de39] {\n  padding: 5px 20px;\n}\n.grid[data-v-0583de39] {\n  margin-bottom: 3px !important;\n}\n.edit-length[data-v-0583de39] {\n  display: none;\n}\n.roll-title:hover .edit-length[data-v-0583de39] {\n  display: inline-block;\n}", ""]);

// exports
